import { render, staticRenderFns } from "./tanimlamalar.vue?vue&type=template&id=34836a19&"
import script from "./tanimlamalar.vue?vue&type=script&lang=js&"
export * from "./tanimlamalar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports